<app-system-message></app-system-message>
<!-- <div [ngClass]="theme.getThemeClass()" class="themeBg"></div> -->

<div [ngClass]="theme.getThemeClass()" class="container-fluid" >
    <div class="page-header">
      <!-- For future development -->
      <!-- <button class="btn back" (click)="backToBinModelList()"><i class="fa fa-arrow-left"></i></button> -->
    <h2>{{"userList" | translate}}</h2>
    </div>
    <!-- Section for search and sort -->
    <nav
      id="search-component"
      class="nav-sort-filter"
    >
      <input
        #searchBox
        type="search"
        id="search-box"
        [(ngModel)]="userFilter"
        (input)="search()"
        (change)="search()"
        class="form-control rounded searchInput"
      placeholder="{{ 'userlistSearchInputPlaceHolder' | translate }}"
      aria-label="Search"
      aria-describedby="search-addon"
    />
      <select
        class="form-control ng-select sort-by-select"
        [(ngModel)]="filterBy"
        [ngClass]="{ 'has-value': filterBy }"
        (change)="search()"
      >
        <option value="">{{ 'filterBy' | translate }}</option>
      @for (option of dispatchUserFilterOptions; track option.value) {
        <option [value]="option.value">{{ option.label | translate }}</option>
      }
      </select>
      <div class="card-title mt-0 status">
        <label class="switch">
            <input type="checkbox" [ngModel]="this.ascDesc" (change)="onSortChange('switch')">
            <span class="slider round">
              <span class="toggle-switch-label-off">{{ "asc" | translate }}</span>
              <span class="toggle-switch-label-on">{{ "desc" | translate }}</span>
            </span>
        </label>
      </div>
      @if (this.currentUserRoles?.includes('_admin')) {
      <button
        type="button"
        class="btn btn-primary header-action-btn"
        [ngClass]="theme.getThemeClass()"
        (click)="openCreateModal()"
      >
        {{ 'createUser' | translate }}
      </button>
      }
    </nav>
  <div class="grid-container" [ngClass]="theme.getThemeClass()">
    <section [ngClass]="theme.getThemeClass()" class="gridster" [ngStyle]="getColumnStyle()">
      @for (item of dispatchUserArray; track item.user; let i = $index) {
      <article class="gridster-item" [ngClass]="theme.getThemeClass()">
        <!-- Your tile content goes here -->
          <nav [ngClass]="theme.getThemeClass()" class="dashboard-tile">
            <!-- client given and last name -->
            <header class="dashboard-tile-header">
              <span class="tile-title">
                <h6 class="dashboard-tile-title" [textContent]="sanitizeDisplay(item.given_name + ' ' + item.family_name)"></h6> &nbsp;
                @if (item.current_role === '_admin') {
                <i class="fa-solid fa-user-gear"></i>
                }
              </span>
              @if (this.currentUserRoles?.includes('_admin')) {
              <button
                class="tile-edit-btn"
                type="button"
                [attr.aria-label]="'editUserAria' | translate"
                (click)="openEditModal(item.user)"
              >
                <i class="fa-solid fa-pen"></i>
              </button>
              }
            </header>
            <div class="tiles-container">
              <div class="titles-items">
                <span class="i"> <i class="fa fa-user"></i> </span><label>{{ item.username}}</label>
              </div>
              <div class="titles-items" (click)="displayAddress(i)" style="cursor: pointer;">
                <span class="i"><i class="fa-solid fa-location-dot pointer"></i></span> @if (item.address) {
                <label style="cursor: pointer;" id="{{i}}" class="address" [textContent]="sanitizeDisplay(item.address)"></label>
                } @else {
                <ng-container [ngTemplateOutlet]="noneApplicable"></ng-container>
                }
              </div>
              <div class="titles-items" >
                <span class="i"><i class="fa-solid fa-phone"></i></span>@if (item.phone_number) {
                <label>{{ item.phone_number }}</label>
                } @else {
                <ng-container [ngTemplateOutlet]="noneApplicable"></ng-container>
                }
              </div>
              <div class="titles-items email">
                <span class="i"><i class="fa-solid fa-at"></i></span><label>{{ item.email }}</label>
              </div>
            </div>
          </nav>
        </article>
    }
  </section>

  </div>

  @if (showEditModal) {
  <div class="modal-backdrop" (click)="closeEditModal()"></div>
  <div class="modal" (click)="$event.stopPropagation()">
    <h3>
      @if (modalMode === 'create') {
      {{ 'createUser' | translate }}
      } @else {
      {{ 'userLabel' | translate }}:
      {{ cognitoService.cognitoUserData.given_name }}
      {{ cognitoService.cognitoUserData.family_name }}
      }
    </h3>
    @if (editLoading) {
    <p class="modal-loading">{{ 'loading' | translate }}</p>
    } @else {
    <form>
      <label class="label-spacer" for="username">{{ 'username' | translate }}</label>
      <div class="input-group mb-3 firstInput">
        <span class="input-group-text" [class.no-edit]="modalMode === 'edit'" id="basic-addon1"><i class="fas fa-user-tie"></i></span>
        <input
          [(ngModel)]="this.cognitoService.cognitoUserData.username"
          type="text"
          class="form-control"
          [class.no-edit]="modalMode === 'edit'"
          name="username"
          placeholder="{{ 'username' | translate }}"
          aria-label="Username"
          aria-describedby="basic-addon1"
          (blur)="this.validationService.validateUsername(this.cognitoService.cognitoUserData.username)"
          [class.error-border]="this.validationService.validationErrorArray[0] == 'usernameInvalid' || this.validationService.validationErrorArray[0] == 'usernameNotUnique'"
          [readonly]="modalMode === 'edit'"
        >
      </div>

      <label class="label-spacer" for="givenName">{{ 'givenName' | translate }}</label>
      <div class="input-group mb-3 firstInput">
        <span class="input-group-text" id="basic-addon1"><i class="fas fa-address-card"></i></span>
        <input
          [(ngModel)]="this.cognitoService.cognitoUserData.given_name"
          type="text"
          class="form-control"
          name="given_name"
          placeholder="{{ 'givenName' | translate }}"
          aria-label="Given Name"
          aria-describedby="basic-addon1"
          (blur)="this.validationService.validateNameInput(this.cognitoService.cognitoUserData.given_name, 'givenName')"
          [class.error-border]="this.validationService.validationErrorArray[0] == 'givenNameInvalid'"
        >
      </div>

      <label class="label-spacer" for="familyName">{{ 'familyName' | translate }}</label>
      <div class="input-group mb-3 firstInput">
        <span class="input-group-text" id="basic-addon1"><i class="far fa-address-card"></i></span>
        <input
          [(ngModel)]="this.cognitoService.cognitoUserData.family_name"
          type="text"
          class="form-control"
          name="family_name"
          placeholder="{{ 'familyName' | translate }}"
          aria-label="Family Name"
          aria-describedby="basic-addon1"
          (blur)="this.validationService.validateNameInput(this.cognitoService.cognitoUserData.family_name, 'familyName')"
          [class.error-border]="this.validationService.validationErrorArray[0] == 'familyNameInvalid'"
        >
      </div>

      <label class="label-spacer" for="deviceClient">{{ 'email' | translate }}</label>
      <div class="input-group mb-3 ">
        <span class="input-group-text" [class.no-edit]="modalMode === 'edit'" id="basic-addon1"><i class="fa fa-envelope"></i></span>
        <input
          [(ngModel)]="this.cognitoService.cognitoUserData.email"
          type="text"
          class="form-control"
          [class.no-edit]="modalMode === 'edit'"
          name="email"
          placeholder="{{ 'email' | translate }}"
          aria-label="Email"
          aria-describedby="basic-addon1"
          (blur)="this.validationService.validateClientEmail(this.cognitoService.cognitoUserData.email)"
          [class.error-border]="this.validationService.validationErrorArray[0] == 'clientEmailInvalid'"
          [readonly]="modalMode === 'edit'"
        >
      </div>

      <label class="label-spacer" for="deviceClient">{{ 'phoneNumber' | translate }}</label>
      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon1"><i class="fa fa-phone"></i></span>
        <input
          [(ngModel)]="this.cognitoService.cognitoUserData.phone_number"
          type="text"
          class="form-control telefone-input"
          name="phone_number"
          placeholder="(000) 000-0000"
          aria-label="Phone Number"
          aria-describedby="basic-addon1"
          (blur)="this.validationService.validatePhoneNumber(this.cognitoService.cognitoUserData.phone_number)"
          [class.error-border]="this.validationService.validationErrorArray[0] == 'clientPhoneInvalid'"
        >
      </div>

      <label class="label-spacer" for="deviceClient">{{ 'address' | translate }}</label>
      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon1"><i class="fas fa-search-location"></i></span>
        <input
          [(ngModel)]="this.cognitoService.cognitoUserData.address"
          id="autocomplete"
          type="text"
          class="form-control"
          name="address"
          (keydown)="onInputAddressKeydown($event);"
          placeholder="{{ 'clientcreateFormInputFindAddress' | translate }}"
          aria-label="Enter a place"
          aria-describedby="basic-addon1"
          (blur)="this.validationService.validateAddress(this.cognitoService.cognitoUserData.address)"
          [class.error-border]="this.validationService.validationErrorArray[0] == 'clientAddressInvalid'"
        >
      </div>

      <label class="toggle-container-label">{{ 'roles' | translate }}</label>
      <div class="toggle-container">
        @for (role of Roles; track role.label) {
        <div class="row">
          <div class="form-group switch-group">
            <label class="switch">
              <input
                type="checkbox"
                [value]="role.label"
                (click)="toggleRole(role.label)"
                [checked]="isRoleChecked(role.label)"
              >
              <span class="slider round"></span>
            </label>
            <label>{{ role.label | translate }}</label>
          </div>
        </div>
        }
      </div>

      <nav class="form-group displayFlex">
        <button (click)="closeEditModal()" [ngClass]="theme.getThemeClass()" type="button" class="btn btn-primary btn-block btnCancel fixed-size">{{ 'clientcreateFormBtnCancel' | translate }}</button>
        <button
          [disabled]="this.systemMessageService.buttonBlocked"
          [ngClass]="theme.getThemeClass()"
          (click)="saveUser()"
          type="submit"
          class="btn btn-primary btn-block fixed-size"
        >
          {{ modalMode === 'create' ? ('clientcreateFormBtnCreateClient' | translate) : ('save' | translate) }}
        </button>
      </nav>
    </form>
    }
  </div>
  }

<ng-template #noneApplicable>
  <label>N/A</label>
</ng-template>
